export default __webpack_public_path__ + "static/media/xinyan.dfa9939d.png";